window.programmeFinderData = () => {

  let _lang = jQuery('.programme-finder__lang').val();
  let _path = drupalSettings.path.baseUrl;

  return {
    search: '',
    studentCategory: 15,
    // filter: 'category',
    filter: 'department',
    categoryItems: [],
    programmeItems: [],
    activeCategory: null,
    categoryCount: 0,
    departmentCount: 0,
    categoryImage: null,
    currentLang: _lang,
    endpoint: (_lang != 'en') ? _path + _lang + '/ajax/programme-finder/filter' : _path + 'ajax/programme-finder/filter',

    init(){
      this.submit();
    },

    submit(){
      const _this = this;
      jQuery.ajax({
          type: 'POST',
          url: this.endpoint,
          data: {
            search: this.search,
            studentCategory: this.studentCategory,
            filter: this.filter,
            currentLang: this.currentLang
          }
      }).done(function (results) {
        console.log('hihi');
        _this.categoryItems = results.categoryItems;
        _this.categoryCount = results.count.field_programme_category;
        _this.departmentCount = results.count.field_programme_department;
        if(_this.categoryItems.length){
          _this.clickCategory(_this.categoryItems[0]['id'])
        }else{
          _this.programmeItems = [];
          _this.categoryImage = [];
        }
      });

      console.log(this.search, this.studentCategory, this.filter);
    },

    clickStudentCategory(studentCategory){
      console.log('yoyo');
      this.studentCategory = studentCategory;
      this.submit();
      if(!jQuery('.programme-finder__categories').hasClass('first-in')){
        jQuery('.programme-finder__categories').addClass('first-in');
      }
      jQuery('.programme-finder__main .inner-wrapper').css('left', '0');
      if(this.activeCategory) {
       this.clickCategory(this.activeCategory);
      }
    },

    clickFilter(filter){
      console.log('bobo');
      this.filter = filter;
      this.submit();
      if(!jQuery('.programme-finder__categories').hasClass('first-in')){
        jQuery('.programme-finder__categories').addClass('first-in');
      }
      jQuery('.programme-finder__main .inner-wrapper').css('left', '0');
    },

    clickCategory(id){
      console.log('hoho');
      this.activeCategory = id;
      const _this = this;

      jQuery.ajax({
        type: 'POST',
        url: _path + 'ajax/programme-finder/get-category',
        data: {
          id: this.activeCategory,
          search: this.search,
          studentCategory: this.studentCategory,
          filter: this.filter,
          currentLang: this.currentLang
        }
      }).done(function (results) {
        console.log(results);
        _this.programmeItems = results.programmeItems;
        _this.categoryImage = results.categoryImage;
        let headerHeight = jQuery('#site-header').outerHeight();

        if(!jQuery('.programme-finder__categories').hasClass('first-in')){
          jQuery('.programme-finder__main .inner-wrapper').css('left', '-100%');
          if(jQuery(window).innerWidth() < 620) {
            jQuery('html, body').stop(true).animate({
              'scrollTop': jQuery('.programme-finder__main').offset().top - headerHeight - 40
            }, 300);
          }
        }else{
          jQuery('.programme-finder__categories').removeClass('first-in');
        }
      });
    },

    clickBackList(){
      jQuery('.programme-finder__main .inner-wrapper').css('left', '0');
    }
  }
};

(function ($) {

  $('.programme-finder__programmes').theiaStickySidebar({
    'additionalMarginTop': 130,
    'minWidth': 620,
    'disableOnResponsiveLayouts': false
  });
})(jQuery);
